import { useEffect, useContext } from 'react';
import { AuthContext } from '../../context/Auth/AuthContext';
import api from '../../services/api';

const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

const PushNotificationManager = () => {
  const { user, isAuth } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuth || !user?.id) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

    const setupPush = async () => {
      try {
        const { data } = await api.get('/push/vapid-public-key');
        if (!data.publicKey) return;

        const registration = await navigator.serviceWorker.ready;
        let subscription = await registration.pushManager.getSubscription();

        if (!subscription) {
          const permission = await Notification.requestPermission();
          if (permission !== 'granted') return;

          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(data.publicKey),
          });
        }

        await api.post('/push/subscribe', {
          endpoint: subscription.endpoint,
          keys: {
            p256dh: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('p256dh')))),
            auth: btoa(String.fromCharCode(...new Uint8Array(subscription.getKey('auth')))),
          },
        });
      } catch (err) {
        // Push no soportado o denegado — silencioso
      }
    };

    const timer = setTimeout(setupPush, 3000);
    return () => clearTimeout(timer);
  }, [isAuth, user?.id]);

  return null;
};

export default PushNotificationManager;
